import { gql } from "lib/apolloClient";
import { workflowProgressFragment } from "./WorkflowsFragments";

export const getWorkflowProgressDataQuery = gql`
  query fetchWorkflowProgressData($subTaskId: ID!) {
    integration {
      fetchWorkflowProgressData(input: { subTaskId: $subTaskId }) {
        ...workflowProgress
      }
    }
  }
  ${workflowProgressFragment.workflowProgress}
`;
